

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { CollapsiblePane, ComponentBase, NumberInput, Overlay, Pagination } from '../components';
import type { Comp, Dict, Utils } from '../types';


type SortField =
    'ID' | 'COL_GROUP' | 'ORDER_NUMBER' | 'NAME_KK' | 'NAME_RU' | 'UNIT_NAME_KK' | 'UNIT_NAME_RU' | 'AGGREGATION'
    | 'WIDTH' | 'DATA_SOURCE' | 'COL_TYPE' | 'SUBPROG_DIST_EDITABLE' | 'DETAILED_REPORT_ONLY' | 'REMOVE_IF_NO_DATA'
    | 'FRACTIONAL_DIGIT_COUNT' | 'FOR_TOTAL' | 'CODE'
;

/**
 * Настройки поиска колонок отчетов штатного расписания
 */
interface DictStRepFormColSearchConfig {
    /**
     * Количество элементов на странице
     */
    itemsPerPage: number | null;

    /**
     * Индекс страницы, нумерация с `0`
     */
    page: number | null;

    /**
     * Набор ID
     */
    idSet: Array<number> | null;

    /**
     * Список ID групп колонок
     */
    colGroupSet: Array<number> | null;

    /**
     * Стартовое значение - Порядковый номер
     */
    orderNumberStartValue: number | null;

    /**
     * Конечное значение - Порядковый номер
     */
    orderNumberEndValue: number | null;

    /**
     * Часть значения - Название на казахском
     */
    nameKkPart: string | null;

    /**
     * Часть значения - Название на русском
     */
    nameRuPart: string | null;

    /**
     * Часть значения - Название единицы измерения на казахском
     */
    unitNameKkPart: string | null;

    /**
     * Часть значения - Название единицы измерения на русском
     */
    unitNameRuPart: string | null;

    /**
     * Список значений - Код вида агрегации.
     */
    aggregationSet: Array<string> | null;

    /**
     * Стартовое значение - Ширина колонки в пикселях
     */
    widthStartValue: number | null;

    /**
     * Конечное значение - Ширина колонки в пикселях
     */
    widthEndValue: number | null;

    /**
     * Список значений - Код источника данных
     */
    dataSourceSet: Array<string> | null;

    /**
     * Список значений - Тип колонки
     */
    colTypeSet: Array<string> | null;

    /**
     * Признак "редактируется при распределении по подпрограммам"
     */
    subprogDistEditable: boolean | null;

    /**
     * Признак "отображать только в расширенном отчете"
     */
    detailedReportOnly: boolean | null;

    /**
     * Признак "удалять колонку, если в ней нет данных"
     */
    removeIfNoData: boolean | null;

    /**
     * Стартовое значение - Количество цифр в дробной части.
     */
    fractionalDigitCountStartValue: number | null;

    /**
     * Конечное значение - Количество цифр в дробной части.
     */
    fractionalDigitCountEndValue: number | null;

    /**
     * Признак "Колонка для отправки в свод"
     */
    forTotal: boolean | null;

    /**
     * Часть значения - Код колонки
     */
    codePart: string | null;

    /**
     * Поле для сортировки
     */
    sortField: SortField | null;

    /**
     * Признак "обратная сортировка" (от большего к меньшему)
     */
    reversedSort: boolean | null;
}


const translates = {
    actions: {
        get add(): string {
            return i18n.choose(
                'Добавить',
                'Қосу',
                'Add',
            );
        },
        get apply(): string {
            return i18n.choose(
                'Применить',
                'Қолдану',
                'Apply',
            );
        },
        get delete(): string {
            return i18n.choose(
                'Удалить',
                'Жою',
                'Delete',
            );
        },
        get edit(): string {
            return i18n.choose(
                'Изменить',
                'Өзгерту',
                'Edit',
            );
        },
        get refresh(): string {
            return i18n.choose(
                'Обновить',
                'Жаңарту',
                'Refresh',
            );
        },
        get save(): string {
            return i18n.choose(
                'Сохранить',
                'Сақтау',
                'Save',
            );
        },
    },
    deletionConfirmationText(id: number): string {
        return i18n.choose(
            () => `Удалить элемент с ID #${id}?`,
            () => `#${id} идентификаторы бар элементті жою керек пе?`,
            () => `Delete element with ID #${id}?`,
        )();
    },
    errors: {
        get cannotDeleteData(): string {
            return i18n.choose(
                'Не удалось удалить данные',
                'Деректерді жою мүмкін болмады',
                'Failed to delete data',
            );
        },
        get cannotLoadData(): string {
            return i18n.choose(
                'Не удалось загрузить данные',
                'Деректерді жүктеу сәтсіз аяқталды',
                'Failed to load data',
            );
        },
        get cannotSaveData(): string {
            return i18n.choose(
                'Не удалось сохранить данные',
                'Деректерді сақтау мүмкін болмады',
                'Failed to save data',
            );
        },
    },
    fields: {
        id: {
            get title(): string {
                return 'ID';
            },
        },
        code: {
            get title(): string {
                return i18n.choose(
                    'Код колонки',
                    'Баған коды',
                    'Column code',
                );
            },
        },
        colGroup: {
            get title(): string {
                return i18n.choose(
                    'ID группы колонок',
                    'Баған тобының ID',
                    'Column group ID',
                );
            },
        },
        orderNumber: {
            get title(): string {
                return i18n.choose(
                    'Порядковый номер',
                    'Сериялық нөмірі',
                    'Order number',
                );
            },
        },
        nameKk: {
            get title(): string {
                return i18n.choose(
                    'Название на казахском',
                    'Аты қазақша',
                    'Name in kazakh',
                );
            },
        },
        nameRu: {
            get title(): string {
                return i18n.choose(
                    'Название на русском',
                    'Орысша атауы',
                    'Name in russian',
                );
            },
        },
        unitNameKk: {
            get title(): string {
                return i18n.choose(
                    'Название единицы измерения на казахском',
                    'Өлшем бірлігінің қазақша атауы',
                    'Measurement unit name in kazakh',
                );
            },
        },
        unitNameRu: {
            get title(): string {
                return i18n.choose(
                    'Название единицы измерения на русском',
                    'Орыс тіліндегі өлшем бірлігінің атауы',
                    'Measurement unit name in russian',
                );
            },
        },
        aggregation: {
            get title(): string {
                return i18n.choose(
                    'Код вида агрегации',
                    'Агрегация түрінің коды',
                    'Aggregation kind code',
                );
            },
        },
        width: {
            get title(): string {
                return i18n.choose(
                    'Ширина колонки в пикселях',
                    'Пиксельдегі баған ені',
                    'Column width in pixels',
                );
            },
        },
        dataSource: {
            get title(): string {
                return i18n.choose(
                    'Код источника данных',
                    'Мәліметтердің бастапқы коды',
                    'Data source code',
                );
            },
        },
        colType: {
            get title(): string {
                return i18n.choose(
                    'Тип колонки',
                    'Баған түрі',
                    'Column type',
                );
            },
        },
        subprogDistEditable: {
            get title(): string {
                return i18n.choose(
                    'Признак "редактируется при распределении по подпрограммам"',
                    '«Ішкі бағдарламаларға тарату кезінде өңделеді» жалаушасы',
                    'Flag "editable when distributed to subprograms"',
                );
            },
        },
        detailedReportOnly: {
            get title(): string {
                return i18n.choose(
                    'Признак "отображать только в расширенном отчете"',
                    '"Тек кеңейтілген есепте көрсету" жалаушасы',
                    'Flag "show only in detailed report"',
                );
            },
        },
        removeIfNoData: {
            get title(): string {
                return i18n.choose(
                    'Признак "удалять колонку, если в ней нет данных"',
                    '"Егер деректер жоқ болса, бағанды жою" деп жалаушалаңыз',
                    'Flag "remove column if no data"',
                );
            },
        },
        fractionalDigitCount: {
            get title(): string {
                return i18n.choose(
                    'Количество цифр в дробной части',
                    'Бөлшек бөлігіндегі цифрлар саны',
                    'Fractional digit count',
                );
            },
        },
        forTotal: {
            get title(): string {
                return i18n.choose(
                    'Признак "Колонка для отправки в свод"',
                    '"Қаймаға жіберілетін баған" жалаушасы',
                    'Flag "column for total"',
                );
            },
        },
        debug: {
            get title(): string {
                return i18n.choose(
                    'Признак "Колонка для отладки"',
                    '«Түзейтін баған» жалаушасы',
                    'The "Debug Column" flag',
                );
            },
        },
        reportTypes: {
            get title(): string {
                return i18n.choose(
                    'Список типов отчетов, в которых будет использоваться колонка',
                    'Баған пайдаланылатын есеп түрлерінің тізімі',
                    'List of report types in which the column will be used',
                );
            },
            values: {
                get COMMON(): string {
                    return i18n.choose(
                        'обычный отчет',
                        'тұрақты есеп',
                        'common report',
                    );
                },
                get DETAILED(): string {
                    return i18n.choose(
                        'расширенный отчет',
                        'кеңейтілген есеп',
                        'detailed report',
                    );
                },
                get DEBUG(): string {
                    return i18n.choose(
                        'отладка',
                        'отладка',
                        'debugging',
                    );
                },
                get FZP_TOTAL(): string {
                    return i18n.choose(
                        'ФЗП - Всего',
                        'ФЗП - Барлығы',
                        'FZP - Total',
                    );
                },
                get FZP_CALC(): string {
                    return i18n.choose(
                        'ФЗП - Расчетные',
                        'ФЗП - Есеп айырысу',
                        'FZP - Calculated',
                    );
                },
                get FZP_NA(): string {
                    return i18n.choose(
                        'ФЗП - Новоприбывшие',
                        'ФЗП - Жаңадан келгендер',
                        'FZP - New arrivals',
                    );
                },
            },
        },
    },
    filterSort: {
        get title(): string {
            return i18n.choose(
                'Фильтры, сортировка',
                'Сүзгілер, сұрыптау',
                'Filter, sort',
            );
        },
        get dontUseValue(): string {
            return i18n.choose(
                'Не использовать фильтрацию',
                'Сүзуді қолданбаңыз',
                'Do not use filtering',
            );
        },
        filter: {
            get copyToMax(): string {
                return i18n.choose(
                    'Скопировать как максимальное значение',
                    'Максималды мән ретінде көшіріңіз',
                    'Copy as maximal value',
                );
            },
            get maxValue(): string {
                return i18n.choose(
                    'Максимальное значение',
                    'Максималды мән',
                    'Maximal value',
                );
            },
            get minValue(): string {
                return i18n.choose(
                    'Минимальное значение',
                    'Ең төменгі мән',
                    'Minimal value',
                );
            },
            get partOfValue(): string {
                return i18n.choose(
                    'Часть значения',
                    'Мағынаның бөлігі',
                    'Part of the value',
                );
            },
            get reset(): string {
                return i18n.choose(
                    'Сбросить фильтры',
                    'Сүзгілерді қалпына келтіру',
                    'Reset filters',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Фильтры',
                    'Сүзгілер',
                    'Filters',
                );
            },
            get valueSet(): string {
                return i18n.choose(
                    'Набор значений',
                    'Мәндер жиыны',
                    'Value set',
                );
            },
            get valueSetByComma(): string {
                return i18n.choose(
                    'Набор значений, разделенных запятыми',
                    'Үтірмен бөлінген мәндер жинағы',
                    'Value set separated by commas',
                );
            },
        },
        sort: {
            get field(): string {
                return i18n.choose(
                    'Поле для сортировки',
                    'Сұрыптауға арналған өріс',
                    'Field for sorting',
                );
            },
            get reversedOrder(): string {
                return i18n.choose(
                    'Сортировать в обратном порядке',
                    'Кері ретпен сұрыптау',
                    'Sort in reverse order',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Сортировка',
                    'Сұрыптау',
                    'Sort',
                );
            },
        },
    },
    messages: {
        dataDeleted(id: number): string {
            return i18n.choose(
                () => `Данные успешно удалены, ID = #${id}`,
                () => `Деректер сәтті жойылды, ID = #${id}`,
                () => `Data deleted successfully, ID = #${id}`,
            )();
        },
        dataSaved(id: number): string {
            return i18n.choose(
                () => `Данные успешно сохранены, ID = #${id}`,
                () => `Деректер сәтті сақталды, ID = #${id}`,
                () => `Data saved successfully, ID = #${id}`,
            )();
        },
    },
};

const newSearchConfig = (): DictStRepFormColSearchConfig => {
    return {
        itemsPerPage: null,
        page: null,
        idSet: null,
        colGroupSet: null,
        orderNumberStartValue: null,
        orderNumberEndValue: null,
        nameKkPart: null,
        nameRuPart: null,
        unitNameKkPart: null,
        unitNameRuPart: null,
        aggregationSet: null,
        widthStartValue: null,
        widthEndValue: null,
        dataSourceSet: null,
        colTypeSet: null,
        subprogDistEditable: null,
        detailedReportOnly: null,
        removeIfNoData: null,
        fractionalDigitCountStartValue: null,
        fractionalDigitCountEndValue: null,
        forTotal: null,
        codePart: null,
        sortField: null,
        reversedSort: null,
    };
};


@Component({
    components: {
        CollapsiblePane,
        NumberInput,
        Overlay,
        Pagination,
    },
})
export default class DictStRepFormColListPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    created() {
        // region Навигация по страницам
        this.$watch('page', () => {
            this.loadIfIdle();
        });
        this.$watch('itemsPerPage', () => {
            this.loadIfIdle();
        });
        // endregion
    }

    protected mounted() {
        this.loadIfIdle();
    }
    // endregion


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private get fieldOptions(): Array<Comp.DropdownItemDef<SortField | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // ID
            {
                value: 'ID',
                text: translates.fields.id.title,
            },

            // COL_GROUP
            {
                value: 'COL_GROUP',
                text: translates.fields.colGroup.title,
            },

            // ORDER_NUMBER
            {
                value: 'ORDER_NUMBER',
                text: translates.fields.orderNumber.title,
            },

            // NAME_KK
            {
                value: 'NAME_KK',
                text: translates.fields.nameKk.title,
            },

            // NAME_RU
            {
                value: 'NAME_RU',
                text: translates.fields.nameRu.title,
            },

            // UNIT_NAME_KK
            {
                value: 'UNIT_NAME_KK',
                text: translates.fields.unitNameKk.title,
            },

            // 'UNIT_NAME_RU'
            {
                value: 'UNIT_NAME_RU',
                text: translates.fields.unitNameRu.title,
            },

            // 'AGGREGATION'
            {
                value: 'AGGREGATION',
                text: translates.fields.aggregation.title,
            },

            // 'WIDTH'
            {
                value: 'WIDTH',
                text: translates.fields.width.title,
            },

            // 'DATA_SOURCE'
            {
                value: 'DATA_SOURCE',
                text: translates.fields.dataSource.title,
            },

            // 'COL_TYPE'
            {
                value: 'COL_TYPE',
                text: translates.fields.colType.title,
            },

            // 'SUBPROG_DIST_EDITABLE'
            {
                value: 'SUBPROG_DIST_EDITABLE',
                text: translates.fields.subprogDistEditable.title,
            },

            // 'DETAILED_REPORT_ONLY'
            {
                value: 'DETAILED_REPORT_ONLY',
                text: translates.fields.detailedReportOnly.title,
            },

            // 'REMOVE_IF_NO_DATA'
            {
                value: 'REMOVE_IF_NO_DATA',
                text: translates.fields.removeIfNoData.title,
            },

            // 'FRACTIONAL_DIGIT_COUNT'
            {
                value: 'FRACTIONAL_DIGIT_COUNT',
                text: translates.fields.fractionalDigitCount.title,
            },

            // 'FOR_TOTAL'
            {
                value: 'FOR_TOTAL',
                text: translates.fields.forTotal.title,
            },

            // CODE
            {
                value: 'CODE',
                text: translates.fields.code.title,
            },
        ];
    }

    private get aggregationOptions(): Array<Comp.DropdownItemDef<string | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // SUM
            {
                value: 'SUM',
                text: 'SUM - сумма',
            },

            // AVG
            {
                value: 'AVG',
                text: 'AVG - среднее арифметическое',
            },
        ];
    }
    // endregion


    // region Навигация по страницам
    private page = 0;
    private itemsPerPage = 25;
    private totalItems = 0;

    private onItemsPerPageChanged(itemsPerPage: unknown): void {
        this.itemsPerPage = (itemsPerPage as number);
    }
    // endregion


    // region Загрузка, общее
    private loading = false;
    private loadingId: symbol | null = null;
    // endregion


    // region Элементы, фильтрация, сортировка
    // noinspection JSMismatchedCollectionQueryUpdate
    private items: Array<Dict.StRepFormCol> = [];

    private filterSortModalVisible = false;
    private filterSortFilterPaneExpanded = false;
    private filterSortSortPaneExpanded = false;

    private filterIdSet: Set<number> = new Set();
    private filterIdSetInput: string = '';
    private filterColGroupSet: Set<number> = new Set();
    private filterColGroupSetInput: string = '';
    private filterOrderNumberStartValue: number | null = null;
    private filterOrderNumberStartValueInput: number | null = null;
    private filterOrderNumberEndValue: number | null = null;
    private filterOrderNumberEndValueInput: number | null = null;
    private filterNameKkPart: string = '';
    private filterNameKkPartInput: string = '';
    private filterNameRuPart: string = '';
    private filterNameRuPartInput: string = '';
    private filterUnitNameKkPart: string = '';
    private filterUnitNameKkPartInput: string = '';
    private filterUnitNameRuPart: string = '';
    private filterUnitNameRuPartInput: string = '';
    private filterAggregationSet: Set<string> = new Set();
    private filterAggregationSetInput: string = '';
    private filterWidthStartValue: number | null = null;
    private filterWidthStartValueInput: number | null = null;
    private filterWidthEndValue: number | null = null;
    private filterWidthEndValueInput: number | null = null;
    private filterDataSourceSet: Set<string> = new Set();
    private filterDataSourceSetInput: string = '';
    private filterColTypeSet: Set<string> = new Set();
    private filterColTypeSetInput: string = '';
    private filterSubprogDistEditable: boolean | null = null;
    private filterSubprogDistEditableInput: boolean | null = null;
    private filterDetailedReportOnly: boolean | null = null;
    private filterDetailedReportOnlyInput: boolean | null = null;
    private filterRemoveIfNoData: boolean | null = null;
    private filterRemoveIfNoDataInput: boolean | null = null;
    private filterFractionalDigitCountStartValue: number | null = null;
    private filterFractionalDigitCountStartValueInput: number | null = null;
    private filterFractionalDigitCountEndValue: number | null = null;
    private filterFractionalDigitCountEndValueInput: number | null = null;
    private filterForTotal: boolean | null = null;
    private filterForTotalInput: boolean | null = null;
    private filterCodePart: string | null = null;
    private filterCodePartInput: string | null = null;

    private sortField: SortField | null = 'ID';
    private tmpSortField: SortField | null = null;
    private reversedSort = false;
    private tmpReversedSort = false;

    private get filterIdSetParsed(): Array<number> {
        return this.filterIdSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }

    private get filterColGroupSetParsed(): Array<number> {
        return this.filterColGroupSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }

    private get filterAggregationSetParsed(): Array<string> {
        return this.filterAggregationSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }

    private get filterDataSourceSetParsed(): Array<string> {
        return this.filterDataSourceSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }

    private get filterColTypeSetParsed(): Array<string> {
        return this.filterColTypeSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }


    private changeFilterSort() {
        this.filterIdSetInput = [...this.filterIdSet].join(', ');
        this.filterColGroupSetInput = [...this.filterColGroupSet].join(', ');
        this.filterOrderNumberStartValueInput = this.filterOrderNumberStartValue;
        this.filterOrderNumberEndValueInput = this.filterOrderNumberEndValue;
        this.filterNameKkPartInput = this.filterNameKkPart;
        this.filterNameRuPartInput = this.filterNameRuPart;
        this.filterUnitNameKkPartInput = this.filterUnitNameKkPart;
        this.filterUnitNameRuPartInput = this.filterUnitNameRuPart;
        this.filterAggregationSetInput = [...this.filterAggregationSet].join(', ');
        this.filterWidthStartValueInput = this.filterWidthStartValue;
        this.filterWidthEndValueInput = this.filterWidthEndValue;
        this.filterDataSourceSetInput = [...this.filterDataSourceSet].join(', ');
        this.filterColTypeSetInput = [...this.filterColTypeSet].join(', ');
        this.filterSubprogDistEditableInput = this.filterSubprogDistEditable;
        this.filterDetailedReportOnlyInput = this.filterDetailedReportOnly;
        this.filterRemoveIfNoDataInput = this.filterRemoveIfNoData;
        this.filterFractionalDigitCountStartValueInput = this.filterFractionalDigitCountStartValue;
        this.filterFractionalDigitCountEndValueInput = this.filterFractionalDigitCountEndValue;
        this.filterForTotalInput = this.filterForTotal;
        this.filterCodePartInput = this.filterCodePart;

        this.tmpSortField = this.sortField;
        this.tmpReversedSort = this.reversedSort;
        this.filterSortModalVisible = true;
    }

    private resetFilter() {
        this.filterIdSetInput = '';
        this.filterColGroupSetInput = '';
        this.filterOrderNumberStartValueInput = null;
        this.filterOrderNumberEndValueInput = null;
        this.filterNameKkPartInput = '';
        this.filterNameRuPartInput = '';
        this.filterUnitNameKkPartInput = '';
        this.filterUnitNameRuPartInput = '';
        this.filterAggregationSetInput = '';
        this.filterWidthStartValueInput = null;
        this.filterWidthEndValueInput = null;
        this.filterDataSourceSetInput = '';
        this.filterColTypeSetInput = '';
        this.filterSubprogDistEditableInput = null;
        this.filterDetailedReportOnlyInput = null;
        this.filterRemoveIfNoDataInput = null;
        this.filterFractionalDigitCountStartValueInput = null;
        this.filterFractionalDigitCountEndValueInput = null;
        this.filterForTotalInput = null;
        this.filterCodePartInput = null;
    }

    private applyFilterSort() {
        this.filterIdSet = new Set(this.filterIdSetParsed);
        this.filterColGroupSet = new Set(this.filterColGroupSetParsed);
        this.filterOrderNumberStartValue = this.filterOrderNumberStartValueInput;
        this.filterOrderNumberEndValue = this.filterOrderNumberEndValueInput;
        this.filterNameKkPart = this.filterNameKkPartInput;
        this.filterNameRuPart = this.filterNameRuPartInput;
        this.filterUnitNameKkPart = this.filterUnitNameKkPartInput;
        this.filterUnitNameRuPart = this.filterUnitNameRuPartInput;
        this.filterAggregationSet = new Set(this.filterAggregationSetParsed);
        this.filterWidthStartValue = this.filterWidthStartValueInput;
        this.filterWidthEndValue = this.filterWidthEndValueInput;
        this.filterDataSourceSet = new Set(this.filterDataSourceSetParsed);
        this.filterColTypeSet = new Set(this.filterColTypeSetParsed);
        this.filterSubprogDistEditable = this.filterSubprogDistEditableInput;
        this.filterDetailedReportOnly = this.filterDetailedReportOnlyInput;
        this.filterRemoveIfNoData = this.filterRemoveIfNoDataInput;
        this.filterFractionalDigitCountStartValue = this.filterFractionalDigitCountStartValueInput;
        this.filterFractionalDigitCountEndValue = this.filterFractionalDigitCountEndValueInput;
        this.filterForTotal = this.filterForTotalInput;
        this.filterCodePart = this.filterCodePartInput;

        this.sortField = this.tmpSortField;
        this.reversedSort = this.tmpReversedSort;
        this.loadIfIdle();
    }

    private loadIfIdle() {
        if (!this.loading) {
            this.load();
        }
    }

    private load() {
        if (this.loading) {
            console.error('Cannot load data - loading already in progress');
            return;
        }

        const searchConfig = newSearchConfig();
        searchConfig.itemsPerPage = this.itemsPerPage;
        searchConfig.page = this.page;
        searchConfig.sortField = this.sortField;
        searchConfig.reversedSort = this.reversedSort;

        if (this.filterIdSet.size > 0) {
            searchConfig.idSet = [...this.filterIdSet];
        }
        if (this.filterColGroupSet.size > 0) {
            searchConfig.colGroupSet = [...this.filterColGroupSet];
        }
        if (this.filterOrderNumberStartValue !== null) {
            searchConfig.orderNumberStartValue = this.filterOrderNumberStartValue;
        }
        if (this.filterOrderNumberEndValue !== null) {
            searchConfig.orderNumberEndValue = this.filterOrderNumberEndValue;
        }
        if (this.filterNameKkPart.length > 0) {
            searchConfig.nameKkPart = this.filterNameKkPart;
        }
        if (this.filterNameRuPart.length > 0) {
            searchConfig.nameRuPart = this.filterNameRuPart;
        }
        if (this.filterUnitNameKkPart.length > 0) {
            searchConfig.unitNameKkPart = this.filterUnitNameKkPart;
        }
        if (this.filterUnitNameRuPart.length > 0) {
            searchConfig.unitNameRuPart = this.filterUnitNameRuPart;
        }
        if (this.filterAggregationSet.size > 0) {
            searchConfig.aggregationSet = [...this.filterAggregationSet];
        }
        if (this.filterWidthStartValue !== null) {
            searchConfig.widthStartValue = this.filterWidthStartValue;
        }
        if (this.filterWidthEndValue !== null) {
            searchConfig.widthEndValue = this.filterWidthEndValue;
        }
        if (this.filterDataSourceSet.size > 0) {
            searchConfig.dataSourceSet = [...this.filterDataSourceSet];
        }
        if (this.filterColTypeSet.size > 0) {
            searchConfig.colTypeSet = [...this.filterColTypeSet];
        }
        if (this.filterSubprogDistEditable !== null) {
            searchConfig.subprogDistEditable = this.filterSubprogDistEditable;
        }
        if (this.filterDetailedReportOnly !== null) {
            searchConfig.detailedReportOnly = this.filterDetailedReportOnly;
        }
        if (this.filterRemoveIfNoData !== null) {
            searchConfig.removeIfNoData = this.filterRemoveIfNoData;
        }
        if (this.filterFractionalDigitCountStartValue !== null) {
            searchConfig.fractionalDigitCountStartValue = this.filterFractionalDigitCountStartValue;
        }
        if (this.filterFractionalDigitCountEndValue !== null) {
            searchConfig.fractionalDigitCountEndValue = this.filterFractionalDigitCountEndValue;
        }
        if (this.filterForTotal !== null) {
            searchConfig.forTotal = this.filterForTotal;
        }
        if (this.filterCodePart !== null) {
            searchConfig.codePart = this.filterCodePart;
        }

        const loadingId = Symbol('DictStRepFormColListPage.load');
        this.loading = true;
        this.loadingId = loadingId;
        this.items = [];

        this.request<Utils.PaginationList<Dict.StRepFormCol>>(
            {
                url: '/api/budget/staffing_table/dict/dict_st_rep_form_col/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.totalItems = data.itemCount;
                this.page = data.page;
                this.items = data.items;
            },
            () => this.translates.errors.cannotLoadData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.loadingId = null;
                this.loading = false;
            },
        );
    }


    private getReportTypesText(row: Dict.StRepFormCol): string {
        let result = '';

        row.reportTypes.forEach((reportType) => {
            let itemText: string;
            switch (reportType) {
                case 'COMMON':
                    itemText = this.translates.fields.reportTypes.values.COMMON;
                    break;
                case 'DETAILED':
                    itemText = this.translates.fields.reportTypes.values.DETAILED;
                    break;
                case 'DEBUG':
                    itemText = this.translates.fields.reportTypes.values.DEBUG;
                    break;
                case 'FZP_TOTAL':
                    itemText = this.translates.fields.reportTypes.values.FZP_TOTAL;
                    break;
                case 'FZP_CALC':
                    itemText = this.translates.fields.reportTypes.values.FZP_CALC;
                    break;
                case 'FZP_NA':
                    itemText = this.translates.fields.reportTypes.values.FZP_NA;
                    break;
                default:
                    itemText = reportType ?? '';
                    break;
            }

            if (result.length > 0) {
                result += ', ';
            }
            result += itemText;
        });

        return result;
    }
    // endregion


    // region Редактируемый элемент
    private elementChangeModalVisible = false;

    /**
     * ID
     *
     * `PRIMARY KEY`
     */
    private changedElementId: number | null = null;

    /**
     * ID группы колонок
     */
    private changedElementColGroup: number = 0;

    /**
     * Порядковый номер
     *
     * _для сортировки колонок внутри группы_
     */
    private changedElementOrderNumber: number = 0;

    /**
     * Название на казахском
     */
    private changedElementNameKk: string = '';

    /**
     * Название на русском
     */
    private changedElementNameRu: string = '';

    /**
     * Название единицы измерения на казахском
     */
    private changedElementUnitNameKk: string = '';

    /**
     * Название единицы измерения на русском
     */
    private changedElementUnitNameRu: string = '';

    /**
     * Код вида агрегации.
     *
     * Применяется только для чисел.
     *
     * Возможные значения:
     * * "SUM" - сумма;
     * * "AVG" - среднее арифметическое.
     */
    private changedElementAggregation: string | null = null;

    /**
     * Ширина колонки в пикселях
     */
    private changedElementWidth: number = 85;

    /**
     * Код источника данных
     */
    private changedElementDataSource: string = '';

    /**
     * Тип колонки
     *
     * Пригодится, если колонка используется в других колонках
     */
    private changedElementColType: string | null = null;

    /**
     * Признак "редактируется при распределении по подпрограммам"
     */
    private changedElementSubprogDistEditable: boolean = false;

    /**
     * Признак "отображать только в расширенном отчете"
     */
    private changedElementDetailedReportOnly: boolean = false;

    /**
     * Признак "удалять колонку, если в ней нет данных"
     */
    private changedElementRemoveIfNoData: boolean = false;

    /**
     * Количество цифр в дробной части.
     *
     * NULL означает "без ограничений" - сколько цифр есть в дробной части, столько и будет отображаться.
     *
     * Значения меньше нуля принимаются равными нулю.
     *
     * Используется при форматировании значений.
     */
    private changedElementFractionalDigitCount: number | null = null;

    /**
     * Признак "Колонка для отправки в свод"
     */
    private changedElementForTotal: boolean = false;

    /**
     * Признак "Колонка для отладки"
     */
    private changedElementDebug: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка
     */
    private changedElementReportTypesCommon: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - расширенный отчет
     */
    private changedElementReportTypesDetailed: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - Отладка
     */
    private changedElementReportTypesDebug: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - "ФЗП - Всего"
     */
    private changedElementReportTypesFzpTotal: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - "ФЗП - Расчетные"
     */
    private changedElementReportTypesFzpCalc: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - "ФЗП - Новоприбывшие"
     */
    private changedElementReportTypesFzpNa: boolean = false;

    /**
     * Код колонки
     */
    private changedElementCode: string | null = null;


    private startElementChange(element?: Dict.StRepFormCol) {
        if (element === undefined) {
            this.changedElementId = null;
            this.changedElementColGroup = 0;
            this.changedElementOrderNumber = 0;
            this.changedElementNameKk = '';
            this.changedElementNameRu = '';
            this.changedElementUnitNameKk = '';
            this.changedElementUnitNameRu = '';
            this.changedElementAggregation = null;
            this.changedElementWidth = 85;
            this.changedElementDataSource = '';
            this.changedElementColType = null;
            this.changedElementSubprogDistEditable = false;
            this.changedElementDetailedReportOnly = false;
            this.changedElementRemoveIfNoData = false;
            this.changedElementFractionalDigitCount = null;
            this.changedElementForTotal = false;
            this.changedElementDebug = false;
            this.changedElementReportTypesCommon = false;
            this.changedElementReportTypesDetailed = false;
            this.changedElementReportTypesDebug = false;
            this.changedElementReportTypesFzpTotal = false;
            this.changedElementReportTypesFzpCalc = false;
            this.changedElementReportTypesFzpNa = false;
            this.changedElementCode = null;
        } else {
            this.changedElementId = element.id;
            this.changedElementColGroup = element.colGroup;
            this.changedElementOrderNumber = element.orderNumber;
            this.changedElementNameKk = element.nameKk;
            this.changedElementNameRu = element.nameRu;
            this.changedElementUnitNameKk = element.unitNameKk ?? '';
            this.changedElementUnitNameRu = element.unitNameRu ?? '';
            this.changedElementAggregation = element.aggregation;
            this.changedElementWidth = element.width;
            this.changedElementDataSource = element.dataSource;
            this.changedElementColType = element.colType;
            this.changedElementSubprogDistEditable = element.subprogDistEditable;
            this.changedElementDetailedReportOnly = element.detailedReportOnly;
            this.changedElementRemoveIfNoData = element.removeIfNoData;
            this.changedElementFractionalDigitCount = element.fractionalDigitCount;
            this.changedElementForTotal = element.forTotal;
            this.changedElementDebug = element.debug;
            this.changedElementReportTypesCommon = element.reportTypes.includes('COMMON');
            this.changedElementReportTypesDetailed = element.reportTypes.includes('DETAILED');
            this.changedElementReportTypesDebug = element.reportTypes.includes('DEBUG');
            this.changedElementReportTypesFzpTotal = element.reportTypes.includes('FZP_TOTAL');
            this.changedElementReportTypesFzpCalc = element.reportTypes.includes('FZP_CALC');
            this.changedElementReportTypesFzpNa = element.reportTypes.includes('FZP_NA');
            this.changedElementCode = element.code;
        }
        this.elementChangeModalVisible = true;
    }

    private saveElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot save data - loading already in progress');
            return;
        }

        const reportTypes: Array<string> = [];
        if (this.changedElementReportTypesCommon) {
            reportTypes.push('COMMON');
        }
        if (this.changedElementReportTypesDetailed) {
            reportTypes.push('DETAILED');
        }
        if (this.changedElementReportTypesDebug) {
            reportTypes.push('DEBUG');
        }
        if (this.changedElementReportTypesFzpTotal) {
            reportTypes.push('FZP_TOTAL');
        }
        if (this.changedElementReportTypesFzpCalc) {
            reportTypes.push('FZP_CALC');
        }
        if (this.changedElementReportTypesFzpNa) {
            reportTypes.push('FZP_NA');
        }

        let code = this.changedElementCode;
        if (code !== null) {
            code = code.trim();
            if (code.length === 0) {
                code = null;
            }
        }

        const data: Dict.StRepFormCol = {
            id: this.changedElementId,
            colGroup: this.changedElementColGroup,
            orderNumber: this.changedElementOrderNumber,
            nameKk: this.changedElementNameKk,
            nameRu: this.changedElementNameRu,
            unitNameKk: this.changedElementUnitNameKk,
            unitNameRu: this.changedElementUnitNameRu,
            aggregation: this.changedElementAggregation,
            width: this.changedElementWidth,
            dataSource: this.changedElementDataSource,
            colType: this.changedElementColType,
            subprogDistEditable: this.changedElementSubprogDistEditable,
            detailedReportOnly: this.changedElementDetailedReportOnly,
            removeIfNoData: this.changedElementRemoveIfNoData,
            fractionalDigitCount: this.changedElementFractionalDigitCount,
            forTotal: this.changedElementForTotal,
            debug: this.changedElementDebug,
            reportTypes: reportTypes,
            code: code,
        };
        if (data.unitNameKk?.length === 0) {
            data.unitNameKk = null;
        }
        if (data.unitNameRu?.length === 0) {
            data.unitNameRu = null;
        }


        const loadingId = Symbol('DictStRepFormColListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        this.request<number>(
            {
                url: '/api/budget/staffing_table/dict/dict_st_rep_form_col',
                method: 'POST',
                data,
            },
            (data) => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataSaved(data),
                );
                this.changedElementId = data;
            },
            () => this.translates.errors.cannotSaveData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementChangeModalVisible = false;
                this.load();
            }
        );
    }
    // endregion


    // region Удаление элемента
    private elementDeletionModalVisible = false;
    private removedElementId: number = 0;

    private startElementDeletion(element: Dict.StRepFormCol) {
        if (element.id === null) {
            console.error('Cannot delete element - ID is NULL');
            return;
        }

        this.removedElementId = (element.id as number);
        this.elementDeletionModalVisible = true;
    }

    private deleteElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot delete element - loading already in progress');
            return;
        }

        const id = this.removedElementId;

        const loadingId = Symbol('DictStRepFormColListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/dict/dict_st_rep_form_col',
            [
                ['id', id],
            ],
        );

        this.request<unknown>(
            {
                url,
                method: 'DELETE',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataDeleted(id),
                );
            },
            () => this.translates.errors.cannotDeleteData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementDeletionModalVisible = false;
                this.load();
            }
        );
    }
    // endregion
}
